export const base64ToBlob = (base64String, contentType = 'image/jpeg') => {
  const byteCharacters = atob(base64String)
  const byteArrays = []

  for (let i = 0; i < byteCharacters.length; i++) {
    byteArrays.push(byteCharacters.charCodeAt(i))
  }

  const byteArray = new Uint8Array(byteArrays)
  return new Blob([byteArray], { type: contentType })
}
